<template>
    <div>
        <div class="column-layout clearfix" v-if="comRoleList != null && comRoleList.length > 0">
            <div class="right-column fl">
                <div style="margin: 5px 0;" class="content-caption dashed">
                    <span class="color-laber">{{comInfo.name}}</span>
                </div>
                <div class="switch-list clearfix ml15">
                    <el-radio-group v-model="comRole">
                        <div v-for="comRole in comRoleList" class="switch-item ellipsis-1" style="width: auto;margin-right: 30px">
                            <el-radio :label="comRole">
                                <span>{{comRole.name}}</span>
                                <el-tag type="success" v-if="comRole.mobAppRoleCode != null" close-transition>{{comRole.mobAppRoleName}}</el-tag>
                            </el-radio>
                        </div>
                    </el-radio-group>
                </div>
            </div>
        </div>
        <div style="text-align: center" class="mt30" v-else>
            <span>暂无岗位信息.....</span>
        </div>
    </div>
</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { checkUserActionPerm } from '../index'
    //
    import servicerApi from '../../api/servicer'
    import servicerAuthxApi from '../../api/servicerAuthx'
    import userApi from '../../api/user'
    //
    import SwbOrgTree from '../orgStruct/OrgTree';
    Vue.regist(SwbOrgTree);
    //
    export default {
        name: 'swb-servicer-com-role-select',
        desc: '人员岗位配置',
        props: {
            comId: {
                type: Number,
                default: null
            },
        },
        data: function () {
            return {
                comInfo: {},
                comRoleList: [],
                //
                comRole: {}
            }
        },
        created: function () {
            //
            this.getComDetail();
            this.getComRoleList();
        },
        methods: {
            getComDetail() {
                let self = this;
                let postData = {
                    comId: this.comId
                };
                let theLoading = MsgBox.loading();
                servicerApi.getServicerCom(postData, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        //
                        self.comInfo = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getComRoleList () {
                let self = this;
                let postData = {};
                postData.comId = this.comId;
                postData.includeOther = true;
                postData.disabled = false;
                //
                let theLoading = MsgBox.loading();
                servicerAuthxApi.getServicerComRoleList(postData, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        //
                        self.comRoleList = result.data || [];
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDlgResult(){
                let result = {};
                let resultData = {};
                if(Utils.isNoB(this.comRole)) {
                    result.type = 'warn';
                    result.message = "请选择岗位信息";
                    return result;
                }
                let comInfo = this.comInfo;
                let comRole = this.comRole;
                resultData.comId = comInfo.id;
                resultData.comName = comInfo.name;
                resultData.comLevel = comInfo.level;
                if(!Utils.isNoB(comRole.id)) {
                    resultData.roleId = comRole.id;
                    resultData.roleName = comRole.name;
                    result.type = 'info';
                    result.data = resultData;
                } else {
                    result.type = 'warn';
                    result.message = "请选择岗位信息";
                }
                return result;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/staffBiz/ServicerComRoleForSelect.vue